export default {
  // 标题
  currencyTokenContract: "币种/代币合约：",
  label: "标签：",
  time: "时间：",
  functionSwitch: "功能开关：",
  sameTimeSameIP: "同时段同IP",

  // 选项
  all: "全部",
  pleaseSelect: "请选择",

  // 日期选择器
  startDate: "开始日期",
  endDate: "结束日期",

  // 功能开关选项
  surveyData: "调证数据",
  firstInflow: "首笔流入",

  // 功能开关提示
  surveyDataTooltip: "可扩展出已上传调证的相关数据",
  firstInflowTooltip: "扩展增加显示首笔主币流入地址",

  // 标签提示
  exchangeUserAddressTooltip: "扩展地址只显示交易所相关标签的地址",
  maliceTypeTooltip: "扩展地址只显示恶意标签的地址",

  // 成功消息
  currencyModifiedSuccess: "币种修改成功",
  labelModifiedSuccess: "标签修改成功",
  timeModifiedSuccess: "时间修改成功",
  switchModifiedSuccess: "开关修改成功",
};
